/**
 * Prefijo de los ítems de «Mi empresa» (`empresa:<grupo>:<clave>`). El panel derecho se retiró (GEN-PX-021) y sus funciones
 * viven en Saber; el kernel aún puede emitirlos y LeftRail los excluye de «otras» para que no salgan como enlaces sueltos.
 */
export const PREFIJO_EMPRESA = 'empresa:'
